export const SUBSCRIPTION_NAMES = {
  OnStateUpdated: 'OnStateUpdated',
  sellerPricingPlanUpdated: 'sellerPricingPlanUpdated',
  sellerPushedToProd: 'sellerPushedToProd',
} as const;

export type SubscriptionNames =
  (typeof SUBSCRIPTION_NAMES)[keyof typeof SUBSCRIPTION_NAMES];
